export enum PlayerTask {
    COIN = 'coin',
    LIVE = 'live',
    TNT = 'tnt',
    BULLS_EYE = 'bulls_eye',
    SHUFFLE = 'shuffle',
    JOKER = 'joker',
    EXTRA_CARDS = 'extraCards',
    UNLOCK_BACKCARD = 'unlockBackcard',
    UNDO = 'undo',
    ICON_HOP = 'iconHop',
    FIELD_FTUX = 'fieldFtux',
    FIELD_UNLOCKED = 'fieldUnlocked',
    SHOW_POPUP = 'showPopup',
    SEND_COINS = 'sendFriendCoins',
    FREE_PLAY_REWARD = 'freePlayReward',
    STAR_CHEST_STAR_REWARD = 'starChestStarReward',
    STAR_CHEST_FTUX = 'starChestFtux',
    QUESTS_FTUX = 'questsFtux',
    SHOW_QUEST_PROGRESS = 'showQuestProgress',
    PET_FTUX = 'petFtux',
    PET_WALK = 'petWalk',
    REWARD_BOOSTER = 'rewardBooster',
    SHOW_WHEEL = 'show_wheel',
    WHEEL_FTUX = 'wheelFTUX',
    HARVEST = 'harvest',
    FARM_BTN_FTUX = 'farmBtnFTUX',
    FARM_FTUX = 'farmFTUX',
    FARM_PET_FTUX = 'farmPetFTUX',
    EVENT_FTUX = 'eventFTUX',
    CONTEXT_TASK = 'contextTask',
    VALENTINES_2023_GIFT = 'valentines2023Gift',
    BLACKFRIDAY_2023_GIFT = 'blackfriday2023Gift',
}
